/* eslint-disable default-param-last */
import { HYDRATE } from "next-redux-wrapper";
import merge from "deepmerge";
import { isEmpty, isObject } from "@/utils/validations";

export const types = {
  INIT_MODULES: "MODULES/INIT_MODULES",
  SET_MODULES: "MODULES/SET_MODULES",
  SET_STATUS_MODULOS: "MODULES/SET_STATUS_MODULOS",
  SET_STATUS_SELECTION: "MODULES/SET_STATUS_SELECTION",
  SET_CARDS: "MODULES/SET_CARDS",
  SET_MULTIBUNDLES_OLD_OPTIONS: "MODULES/SET_MULTIBUNDLES_OLD_OPTIONS",
  SELECT_MODULES: "MODULES/SELECT_MODULES",
  SELECT_MODULES_URL: "MODULES/SELECT_MODULES_URL",
  SET_TEXTS: "MODULES/SET_TEXTS",

  /* nextjs */
  HYDRATE: "MAIN/HYDRATE",
};

export const actions = {
  initModules: (
    data = {
      build: false,
      client: null,
      sessionZoneId: null,
      urlParams: null,
    }
  ) => ({ type: types.INIT_MODULES, ...data }),
  setModules: (data) => ({ type: types.SET_MODULES, items: data }),
  setCards: (data) => ({ type: types.SET_CARDS, items: data }),
  setTexts: (data) => ({ type: types.SET_TEXTS, legalTexts: data }),

  setmultibundleOldOptions: (data) => ({
    type: types.SET_MULTIBUNDLES_OLD_OPTIONS,
    ids: data,
  }),
  setStatusModulos: (data) => ({
    type: types.SET_STATUS_MODULOS,
    status: data,
  }),
  setStatusSelection: (data) => ({
    type: types.SET_STATUS_SELECTION,
    status: data,
  }),
  selectModulesUrl: (
    data = {
      ids: null,
    }
  ) => ({ type: types.SELECT_MODULES_URL, ...data }),
  selectModules: (
    data = {
      ids: null,
      urlParamsSelection: null,
      category: null,
      subcategory: null,
    }
  ) => ({ type: types.SELECT_MODULES, ...data }),
};

const initialState = {
  statusModulos: null,
  statusSelection: null,
  items: null,
  cards: null,
  multibundleOldOptions: {},
  legalTexts: null,
};

function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      const { modulos } = action.payload;
      /* neceisto preservar lo que viene del sever excepto los filtros */
      const nextState = merge(state, modulos);
      return nextState;
    }
    case types.SET_MODULES: {
      const { items } = action;
      return {
        ...state,
        ...items,
      };
    }
    case types.SET_STATUS_MODULOS: {
      const { status } = action;
      return {
        ...state,
        statusModulos: status,
      };
    }
    case types.SET_STATUS_SELECTION: {
      const { status } = action;
      return {
        ...state,
        statusSelection: status,
      };
    }
    case types.SET_CARDS: {
      const { items } = action;
      return {
        ...state,
        cards: items?.orion,
      };
    }
    case types.SET_TEXTS: {
      const { legalTexts } = action;
      if(!state?.legalTexts){
        return {
          ...state,
          legalTexts: legalTexts,
        };
      }
    }
    
  

    case types.SET_MULTIBUNDLES_OLD_OPTIONS:
      {
        const { ids } = action;
        let newOptions = { ...ids };
        let oldOptions = {};
        if (isObject(state?.multibundleOldOptions)) {
          oldOptions = { ...state?.multibundleOldOptions };
        }
        if (!isEmpty(oldOptions)) {
          newOptions = { ...oldOptions, ...ids };
        }
        return {
          ...state,
          multibundleOldOptions: newOptions,
        };
      }
      const { ids, category, subcategory } = action;

      return {
        ...state,
        [category]: {
          ...state[category],
          [subcategory]: {
            ...state[category][subcategory],
            items: state[category][subcategory]?.items.map((element) =>
              ids.includes(element.id)
                ? { ...element, selected: !element.selected }
                : element
            ),
          },
        },
      };

    default:
      return state;
  }
}

export default reducer;
